import { render } from "./TradeSettingsPopover.vue?vue&type=template&id=fd4718f8&ts=true"
import script from "./TradeSettingsPopover.vue?vue&type=script&lang=ts"
export * from "./TradeSettingsPopover.vue?vue&type=script&lang=ts"

import "./TradeSettingsPopover.vue?vue&type=style&index=0&id=fd4718f8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__